export default {
  allNotifications: (state) => state.notifications,
  systemNotifications: (state) => state.notifications.filter(notification => notification.type === 0),
  userNotifications: (state) => state.notifications.filter(notification => notification.type === 1)
}
